<!-- BaseToggleSwitch.vue (client) -->
<template tag="클라이언트 토글스위치 컴포넌트">
  <div class="toggle_switch">
    <label>
      <input
        type="checkbox"
        :checked="model"
        :disabled="disabled"
        @click.prevent="model = !model"
      />
      <span>스위치</span>
    </label>
  </div>
</template>

<script setup lang="ts">
import { defineModel } from "vue";

withDefaults(defineProps<{ disabled?: boolean }>(), {
  disabled: false,
});

/* ------------------------------------------------------------
                          Model
   ------------------------------------------------------------ */
const model = defineModel<boolean>({ default: false });
</script>
